import { Fragment } from "react";

const ADDRESS = /([\w.+-]+@[\w-]+(?:\.[\w-]+)*\w)/;

/** A sentence with each email address in it set bold, as the sign-in mock-ups draw an address in a message. */
export function BoldAddresses({ text }: { text: string }) {
  return (
    <>
      {text.split(ADDRESS).map((part, index) => (
        <Fragment key={index}>
          {index % 2 === 1 ? <b>{part}</b> : part}
        </Fragment>
      ))}
    </>
  );
}
